import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useQuoteWorkspacePreload } from '@/features/quote-builder/api/preload'

export const Route = createFileRoute('/_authenticated/quotes')({
  component: QuotesLayout,
})

function QuotesLayout() {
  useQuoteWorkspacePreload()
  return <Outlet />
}
